<template lang="pug">
  .about.h-100
    .container-fluid.about-bkg.sub_texture
      .row.h-100
        .col-12.col-md-6
          svg-inline(
            src="/scenes/traffic_bkg.png"
            :svg="false"
            :position="{x: -10,y: 10}"
            :scale=1.3
            style="width: 100%;",
            v-if="gameMode==''"
            )
          svg-inline(
            src="/scenes/traffic_obj.svg"
            :svg="true"
            :position="{x: -10,y: 10}"
            :scale=1.3
            :displayExclamation="false"
            style="width: 100%;",
            v-if="gameMode==''"
            )
          
            
        //- .offset-6
        // .col-12.col-md-6.h-100
          img.about-bkg(src="@/assets/images/about-bkg.png")
        .col-12.col-md-6.about-main.animate__animated.animate__fadeIn
          .about-content.p-4.p-md-5
            h1.mt-1 {{ $t('about.title') }}
            span {{ $t('about.desc') }}
            br
            br
            .ratio-wrapper
              iframe.about-video.animate__animated.animate__fadeIn(:src="$t('about.video')" 
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
            a.download-handbook.mt-5(:href="$t('about.brochure_url')" target="_blank") {{ $t('about.brochure') }}
</template>

<script>
import SvgInline from "@/components/SvgInline.vue";
import BuildingGame from "@/components/BuildingGame"
let bg_animation = require("@/assets/animations/traffic.js");
export default {
  name: "About",
  data(){
    return {
      gameMode: ''
    }
  },
  components: {
    SvgInline,
    BuildingGame
  },
  mounted() {
    this.$store.dispatch("loadSvgData", "/scenes/traffic_obj.svg").then(() => {
      setTimeout(() => {
        bg_animation.play();
      }, 100);
    });
  },
};
</script>

<style scoped lang="sass">
.about
  width: 100vw
  height: 100%
  min-height: 100vh
  max-height: 100%
  background-color: #F47457
  overflow: hidden
  .svg_inline
    z-index: 1
  .about-main
    height: 100%
    position: relative
    z-index: 500
  .about-bkg
    background-image: url(/img/index_grid.svg)
  .about-content
    color: black
    line-height: 1.8
    letter-spacing: 1.2px
    height: calc(100vh - 32px)
    max-height: calc(100% - 32px)
    border: 15px solid white
    border-radius: 15px
    // box-sizing: border-box
    background-color: white
    // padding: 50px 30px
    overflow-y: auto
    overflow-x: hidden
    margin-top: 1rem
    h1
      margin-left: 30px
      font-weight: 700
      margin-bottom: 30px
      position: relative
      &:before
        content: ''
        background: url("../assets/images/triangle-right.svg")
        position: absolute
        background-repeat: no-repeat
        background-position: center
        left: -50px
        width: 45px
        height: 45px
        // border: solid 1px black
    span
      font-size: 18px
    .ratio-wrapper
      width: 100%
      padding-bottom: calc(1080/1920*100%)
      background-color: #333
      position: relative
    iframe.about-video
      position: absolute
      width: 100%
      height: 100%
    .download-handbook
      font-size: 1rem
      display: block
      width: 100%
      padding: 10px
      border: solid 2px black
      font-weight: bold
      border-radius: 100px
      text-align: center
      margin-left: 50%
      transform: translateX(-50%)
      text-decoration: none
      color: black
      transition: 0.15s
      &:hover
        color: white
        cursor: pointer
        background-color: #F47457
        border-color: transparent

@media (max-width: 768px)
  .about
    // height: 100%
    height: auto
    max-height: initial
    overflow-y: auto
    padding-bottom: 100px !important
    .about-main
      // padding-top: 50vh
      padding-bottom: 100px
    .about-bkg
      height: 100%
      background-size: cover
      background-position: 0% 50%
    .about-content
      display: inline-block
      margin-top: 50vh
      margin-bottom: 30px
      max-height: initial
      overflow-y: auto
      // margin: 50vh 0 600px 0
      // height: calc(98vh - 100px)
      height: auto
      // height: fit-content
      // max-height: initial
      border: 10px solid white
      h1
        margin-top: 20px
        margin-left: 50px
</style>
